/**
 * The 1080×1920 canvas every layout is drawn on, scaled to fit the space it is given (1:1 on the totem).
 * It carries the look of the active mode and the domain's brand as attributes and CSS variables.
 */
import { useLayoutEffect, useRef, useState, type CSSProperties, type ReactNode } from 'react';
import { CANVAS } from '../layout/model';
import css from './Shell.module.css';

export function Canvas({ look, theme, onTouch, children }: {
  look: Record<string, string>;
  theme?: Record<string, string>;
  onTouch?: () => void;
  children: ReactNode;
}) {
  const frame = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const el = frame.current;
    if (!el) return;
    const fit = () => setScale(Math.min(el.clientWidth / CANVAS.width, el.clientHeight / CANVAS.height));
    fit();
    const observer = new ResizeObserver(fit);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const attributes = Object.fromEntries(Object.entries(look).map(([k, v]) => [`data-${k}`, v]));
  return (
    <div ref={frame} className={css.frame}>
      <div
        id="kiosk-root"
        className={css.canvas}
        style={{ ...(theme as CSSProperties), width: CANVAS.width, height: CANVAS.height, transform: `translate(-50%, -50%) scale(${scale})` }}
        onPointerDownCapture={onTouch}
        {...attributes}
      >
        {children}
      </div>
    </div>
  );
}
